import BoardsSettingsControls = require("Agile/Scripts/Board/BoardsSettingsControls");
import CardStyleCustomization_NO_REQUIRE = require("Agile/Scripts/Card/CardCustomizationStyle");
import TeamServices = require("TfsCommon/Scripts/Team/Services");
import { registerCardSettings } from "Agile/Scripts/Settings/CardSettingsConfiguration";
import { registerGeneralSettings } from "Agile/Scripts/Settings/GeneralSettingsConfiguration";
import { IBugSettingData } from "Agile/Scripts/Admin/TeamSettings";

export function registerTaskboardSettingsForIterationLevel(
  teamId: string,
  currentUserTeamPermissions: TeamServices.ITeamPermissions,
  showBacklogVisibilitiesTab: boolean,
  fieldOptions: BoardsSettingsControls.IFieldSettingsControlOptions,
  styleOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
  bugSettingData?: IBugSettingData
) {
  registerCardSettings(fieldOptions, styleOptions, null);
  registerGeneralSettings(
    teamId,
    currentUserTeamPermissions,
    showBacklogVisibilitiesTab,
    bugSettingData
  );
}
